<template>
  <tr v-for="i in pageSize" :key="i" class="animate-pulse bg-white">
    <td
      v-for="column in columns"
      :key="column.key"
      :class="['px-4 py-4 sm:px-6 align-middle text-left', column.cellClass]"
    >
      <div
        :class="['h-3 rounded-full bg-gray-200/80', getSkeletonWidth(column)]"
      ></div>
    </td>
  </tr>
</template>

<script>
export default {
  name: "LoadingRows",
  props: {
    columns: { type: Array, required: true },
    pageSize: { type: Number, default: 6 },
  },
  methods: {
    getSkeletonWidth(column) {
      if (column.skeletonClass) {
        return column.skeletonClass;
      }
      return "w-24";
    },
  },
};
</script>
